module.exports = __webpack_public_path__ + "static/media/friend-request.923f3d66.png";